"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _iterables = require("rich-text-lib/utils/iterables");

var _ToolbarButton = _interopRequireDefault(require("rich-text-lib/components/toolbar/ToolbarButton"));

var InsertControlButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(InsertControlButton, _Component);

  function InsertControlButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InsertControlButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InsertControlButton).call(this, props));
    _this.state = {
      isActive: false
    };
    _this.handleNodeChange = _this.handleNodeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InsertControlButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.editor.on('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.editor.off('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "handleNodeChange",
    value: function handleNodeChange(evt) {
      var isActive = this.props.isActiveHandler(evt);

      if (isActive !== this.state.isActive) {
        this.setState({
          isActive: isActive
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.props.onClick({
        isActive: this.state.isActive
      });
    }
  }, {
    key: "render",
    value: function render() {
      var buttonProps = (0, _iterables.omit)(Object.keys(InsertControlButton.propTypes), this.props);
      return _react.default.createElement(_ToolbarButton.default, (0, _extends2.default)({}, buttonProps, {
        onClick: this.handleClick,
        selected: !!this.state.isActive
      }));
    }
  }]);
  return InsertControlButton;
}(_react.Component);

exports.default = InsertControlButton;
InsertControlButton.propTypes = {
  editor: _react.PropTypes.object.isRequired,
  isActiveHandler: _react.PropTypes.func.isRequired,
  onClick: _react.PropTypes.func.isRequired
};
InsertControlButton.defaultProps = {
  isActiveHandler: function isActiveHandler() {
    return false;
  }
};
module.exports = exports.default;